<script>
  import { range } from 'd3-array';
  import { scaleLinear } from 'd3-scale';
  import { numberFormat } from '../utils/d3-utils';
  export let title = 'Confirmed cases';
  export let color;
  export let tickLabel = undefined;
  export let tickFormatFunc = (i, scale) => numberFormat(Math.floor(scale[i], i), 1);
  export let tickSize = 4;
  export let width = 280;
  export let height = 44 + tickSize;
  let marginTop = 18;
  let marginRight = 0;
  let marginBottom = 16 + tickSize;
  let marginLeft = 0;
  $: colors = color.range();
  $: thresholds = color.domain();
  $: x = scaleLinear()
    .domain([-1, colors.length - 1])
    .rangeRound([marginLeft, width - marginRight]);
  $: tickValues = range(thresholds.length);
  $: tickFormat = (v) => tickFormatFunc(v, thresholds);
</script>

<svg
  {width}
  {height}
  viewBox="0,0,{width},{height}"
  style="overflow: visible; display: block;"
>
  <g>
    <text
      class="legend-title"
      x={marginLeft}
      y="0.75em"
      fill="currentColor"
      text-anchor="start"
    >
      {title}
    </text>
  </g>
  <g data-length="{colors.length}">
    {#each colors as color, idx}
      <rect
        x={x(idx - 1)}
        y={marginTop}
        width={x(idx) - x(idx - 1)}
        height={height - marginTop - marginBottom}
        fill={color}
      />
    {/each}
  </g>
  <g class="axis x-axis">
    {#each tickValues as tick, idx}
      {#if (idx+1) < colors.length}
      <g class="tick tick-{tick}" transform="translate({x(tick)}, {height})" data-idx="{idx}">
        <line y1="-{height}" y2="-{marginBottom}" x1="0" x2="0" />
        <text class="legend-tick" y="-0.5em" text-anchor="middle">
          {tickFormat(tick)}
          {#if idx === 0 && tickLabel}{tickLabel}{/if}
        </text>
      </g>
     {/if}
    {/each}
  </g>
</svg>